import React from 'react';
import HorsLyceeFields from '../FormCommande/Components/AdresseLivraison/PrivateShopFields/HorsLycee';
import ProFields from '../FormCommande/Components/ProFields';
import { Switch } from '../../../atoms/Buttons/Switchs/Switch';
import useStyle from './updateCommande.style';
import { FormInvoiceInformation } from 'components/molecules/Forms/FormInvoiceInformation';
import { NgoField } from '../FormCommande/Components/NgoField';

export const ClientFieldsUpdate = ({
  errors,
  client,
  handleChange,
  handleChangeSwitch,
  handleCheckSwitch,
  ngoContribution
}) => {
  const classes = useStyle();
  return (
    <div className={classes.formContainer}>
      <FormInvoiceInformation
        handleChange={handleChange}
        handleChangeSwitch={handleChangeSwitch}
        client={client}
        errors={errors}
      />
      <div className={classes.form}>
        <div className={classes.switchTextContainer}>
          <p>Le client souhaite une livraison directe par transporteur ?</p>
          <Switch
            onClick={value =>
              handleCheckSwitch(value, 'livraisonhorslycee', 'client')
            }
            defaultValue={client.livraisonhorslycee}
          />
        </div>
        {client.livraisonhorslycee && (
          <HorsLyceeFields
            handleChange={handleChange}
            handleChangeSwitch={handleChangeSwitch}
            client={client}
            sameClient={false}
            errors={errors}
          />
        )}
      </div>
      <div className={classes.form}>
        <ProFields onChange={handleChange} defaultValues={client} />
      </div>
      <div className={classes.form}>
        <NgoField
          onChange={value =>
            handleCheckSwitch(value, 'customerContributedToTheOng', 'commande')
          }
          defaultValue={ngoContribution}
        />
      </div>
    </div>
  );
};
